import { ClientConfig } from '#/client-config';

export function login(): void {
  window.location.href = ClientConfig.loginUrl;
}

export function logout(): void {
  window.location.href = ClientConfig.logoutUrl;
}
